import { defineNuxtPlugin, onNuxtReady } from "nuxt/app";
export default defineNuxtPlugin(() => {
  onNuxtReady(() => {
    document.documentElement.setAttribute("data-nuxt-page-finish", "");
  });
});
